export enum ResponseType {
  Text = "text",
  Jobs = "jobs",
  Options = "options",
  Scheduling = "interview",
  ResumeUpload = "resume",
  SingleSelect = "single_select",
  SlotPicker = "slot_picker",
  JobResult = "job_result",
  TimeStamp = "timeStamp",
  NoJobs = "no_jobs",
  TNC = "tnc",
  TncAccepted = "tnc_accepted",
  Reset = "reset",
  Form = "form",
  TextWithLinks = "text_with_links",
  VideoInterview = "video_interview",
  DateRange = "date_range",
  TextArea = "text_area",
  ReviewApplication = "review_pii",
  LeadCapture = "lead_capture_consent",
  // form types
  FirstName = "first_name",
  LastName = "last_name",
  Email = "email",
  OTP = "otp",
  PhoneNumber = "phone_number",
  TextInput = "text",
  FullName = "full_name",
  Address = "address",

  FormBoolean = "toggle",
  Select = "select",
  Checkbox = "checkbox",
  InterviewReSchedule = "json_options",
  QuestionSet = "question_set",
  PendingApplies = "pending_applies",
  TranslationToggle = "translation_toggle",
  Autocomplete = "auto_complete",
  // types below - left or main pane
  Video = "video",
  Blog = "blog",
  WebLink = "web-link",
  MultiMedia = "multiMedia",
  // types below- left pane
  ApplyForm = "apply",
  JobDetail = "jobDetail",
  JobListMap = "jobs_with_list_and_map",
}
